import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared';
import { VacationComponent } from './components/vacation-management/vacation/vacation.component';
import { VacationManagementComponent } from './components/vacation-management/vacation-management/vacation-management.component';
import { PersonAgeComponent } from './components/person-age/person-age.component';
import { PersonPersonalDataFieldComponent } from './components/person-personal-data-field/person-personal-data-field.component';
import { PaymentAgreementComponent } from '@crm/shared/persons/components/payment-agreement/payment-agreement.component';
import { SharedLayoutModule } from '@shared/layout';
import { RouterModule } from '@angular/router';
import { PrettyMinusPipe } from './pipes/pretty-minus.pipe';
import { PaymentStatusPipe } from './pipes/payment-status.pipe';

@NgModule({
  imports: [SharedModule, SharedLayoutModule, RouterModule],
  declarations: [
    VacationComponent,
    VacationManagementComponent,
    PersonAgeComponent,
    PersonPersonalDataFieldComponent,
    PaymentAgreementComponent,
    PrettyMinusPipe,
    PaymentStatusPipe,
  ],
  exports: [
    VacationManagementComponent,
    PersonAgeComponent,
    PersonPersonalDataFieldComponent,
    PaymentAgreementComponent,
    PrettyMinusPipe,
    PaymentStatusPipe,
  ],
})
export class SharedPersonsModule {}
